module.exports = __webpack_public_path__ + "static/media/achesoothe-1.2fecee99.png";